function EvidenceLevel() {
  return (
    <div>
      <li className="bullet-item">
        The Evidence Level (EL) is a metric used by ClinGen and GenCC that measures the strength of evidence
        of a gene-disease relationship that correlates to a qualitative classification: 
        <i>
          “Definitive”, “Disputed”, “Limited”, “Moderate”, “No
          Known Disease Relationship”, “Refuted”, “Strong”</i> or <i>“Supportive”
        </i>
        . GDAs that have been reported by ClinGen or GenCC will have their corresponding Evidence Level.
      </li>
    </div>
  );
}

export default EvidenceLevel;
